import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams, PAGINATION_FIELDS } from "../http-params.util";

/**
 * FinanceApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/financeApi/financeApi.service.js.
 *
 * `reports.download(name)` triggers a browser-driven download by navigating
 * the window to the file URL. Preserved verbatim from the legacy — the file
 * is served with `Content-Disposition: attachment`.
 */
const REPORT_TRANSACTION_FILES_BASE = "/v1/api/report/transaction/files";

@Injectable({ providedIn: "root" })
export class FinanceApiService {
  private readonly http = inject(HttpClient);

  readonly reports = {
    list: (props?: Record<string, unknown>): Promise<AjsResponse<unknown>> =>
      wrapAjs(
        this.http.get<unknown>(REPORT_TRANSACTION_FILES_BASE, {
          params: buildParams(props, PAGINATION_FIELDS),
        }),
      ),

    download: (name: string): void => {
      window.location.href = `${REPORT_TRANSACTION_FILES_BASE}/${name}`;
    },
  };
}
